import { Alert, Box, keyframes, Snackbar, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Btn2} from '../StyledComponents'
import DownloadIcon from '@mui/icons-material/Download';
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import Links from './Links';
import { Link } from 'react-router-dom';
import { useTheme } from '@emotion/react';

export function Profession({sx={title:"",caption:""}})
{
    const [border, setBorder] = useState("");
    let theme=useTheme();
    const rolesData = [
        {
            title: ["A Dedicated","Full Stack" ,"Developer"],
            caption: "I'm a full stack developer with a deep love for coding, passionately creating innovative, efficient, and user-friendly web applications that make a difference."
        },
        {
            title: ["A Passionate", "Trainer"],
            caption: "I'm a dedicated trainer who simplifies complex tech concepts, igniting curiosity and empowering learners to build real-world skills with confidence."
        },
        {
            title: ["A Professional", "Freelancer"],
            caption: "I'm a results-driven freelancer who brings ideas to life—delivering quality, reliability, and custom-built digital solutions tailored to every client's vision."
        }
    ];
    
    const [ind, setInd] = useState(0);


    useEffect(()=>{
        console.log(ind+"dfghjk") 
       let interval= setInterval(()=>{
            setInd(prev=>{
                prev++
                if(prev>2)
                {
                    return 0
                }
                else
                {
                    return prev;
                }
            });
        },4000);
        return ()=>clearInterval(interval);
      },[]);

    // const animate = keyframes`
    //     from {
    //         width:0px;
    //     }
    //     to {
    //         width:${rolesData[ind].width+200}px;
    //     }
    // `;
    // const blink = keyframes`
    //     from {
    //         border-color:${theme.palette.primary.light};
    //     }
    //     to {
    //         border-color:${theme.palette.primary.main};
    //     }
    // `;
    return(
        <Box
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <Box
                sx={{
                    overflow:"hidden",
                    margin:'auto',
                }}
                
            >
                <Box 
                    mb={3}
                    sx={{ 
                        ...sx.title,
                        // display:"flex", 
                        justifyContent:'center',
                        color: 'text.primary',
                        // backgroundColor:"red",
                        // width:rolesData[ind].width,
                        flexDirection:"row",
                        // textWrap:"nowrap",
                        // overflow:"hidden",
                        // animation: `${animate} 3s steps(${rolesData[ind].title.join("").length},start) infinite alternate,${blink} 0.6s linear infinite`,
                        // animationFillMode:"forwards",
                        // textAlign:'center'
                    }} 
                    
                >
                    <Typography variant="h5" sx={{color:"text.primary" , display:"inline-block"}} >
                        {rolesData[ind].title[0]}
                    </Typography>
                    <Typography variant="h5" sx={{ color: 'secondary.main', display: "inline-block" }}>
                        &nbsp;{rolesData[ind].title[1]}&nbsp;
                    </Typography>
                    <Typography variant="h5" sx={{ color: "text.primary", display: "inline-block" }}>
                        {rolesData[ind].title[2]}
                    </Typography>
                    
                </Box>
            </Box>
            <Box variant='h7' sx={{...sx.caption, color: 'shade.light', }} data-aos="fade-up" data-aos-duration="2000">
                {rolesData[ind].caption}

            </Box>
        </Box>
    )
}

function Content() {

    const [downloadStatus, setDownloadStatus] = useState('Resume');

    const [openStatus, setOpenStatus] = React.useState(false);
    const [statusMessage, setStatusMessage] = React.useState("");



    const handleDownload = async () => {
        if(downloadStatus=="Downloaded")
            return;
        try {
          setDownloadStatus('downloading...');
          const response = await fetch('/resume.pdf');
    
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
    
          const blob = await response.blob();
          console.log(blob)
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'resume.pdf'; 
          link.click();
          
          setDownloadStatus('Downloaded'); 
          setStatusMessage('Download complete! Thank you for your support.');
        } catch (error) {
          setDownloadStatus('error');
          setStatusMessage('Oops! We encountered an issue with the download. Please try again later.');
        } finally {
           setOpenStatus(true);
        }
      };

      

      const closeStatus = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenStatus(false);
      };

    //   

  return (

    <Box >
        <Box 
           
            sx={{
                display:"flex",
                flexDirection:"column",
                alignItems:{xs:"center",sm:"center",md:"flex-start"},
                gap:"25px",
                textAlign:{xs:"center",sm:"center",md:"left"},
            }}
            
        >       
            <Typography variant="h5" sx={{color:'text.primary'}} data-aos="fade-up" data-aos-duration="2000">
                Hello, I'm
            </Typography>
            <Typography variant="h3" sx={{color:'primary.main'}} data-aos="fade-up" data-aos-duration="2000">
                Sharief
            </Typography>
              <Profession/>
            <Stack direction="row" spacing={2} >
                <Btn2 
                    component={Link}
                    to="?section=contact"
                    sx={{
                        fontSize:{xs:"0.8rem",sm:"1rem",md:"1.08rem"},
                        padding:{xs:"5px 20px",sm:"5px 25px",md:"5px 35px"}, 
                    }}
                    data-aos="fade-up" data-aos-duration="2000"
                >
                    HireMe
                </Btn2>
                <Btn2 
                    onClick={handleDownload}
                    sx={{
                        fontSize:{xs:"0.8rem",sm:"1rem",md:"1.08rem"},
                        padding:{xs:"5px 20px",sm:"5px 25px",md:"5px 35px"}, 
                        '&:after':{
                            height:"100%"
                        },
                        '&:hover:after':{
                            height:"0%"
                        }
                    }}
                    data-aos="fade-up" data-aos-duration="2000"
                >    
                    {downloadStatus}
                    {downloadStatus=="Downloaded"? <FileDownloadDoneIcon/>:<DownloadIcon/>}
                </Btn2>
                <Snackbar open={openStatus} autoHideDuration={6000} onClose={closeStatus}>
                    <Alert
                        onClose={closeStatus}
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {statusMessage}
                    </Alert>
                </Snackbar>
            </Stack>
            <Stack direction="row"
                sx={{
                    display:"flex",
                    gap:"10px",
                }}
                data-aos="fade-up" data-aos-duration="2000"
            >
                <Links size={{xs:"20",sm:'30',md:"30"}} color='secondary.main'/>
            </Stack>
        </Box>
    </Box>
  )
}

export default Content